import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => (
  <div className="privacy-policy-container">
    <h2>🔐 POLÍTICA DE PRIVACIDAD</h2>
    <p><strong>Versión:</strong> agosto 2025</p>
    <ol>
      <li>
        <strong>IDENTIDAD DEL RESPONSABLE</strong><br />
        Responsable: Persona física titular de la app Cookychat (en fase de prueba).<br />
        Correo de contacto: cookychatapp@gmail.com
      </li>
      <li>
        <strong>FINALIDAD DEL TRATAMIENTO</strong><br />
        En Cookychat tratamos los datos personales del usuario para:
        <ul>
          <li>Crear y gestionar una cuenta de usuario.</li>
          <li>Personalizar la experiencia culinaria y social.</li>
          <li>Analizar hábitos de uso para mejorar la app.</li>
          <li>Crear audiencias genéricas para mostrar publicidad.</li>
          <li>Cumplir con obligaciones legales.</li>
        </ul>
      </li>
      <li>
        <strong>DATOS PERSONALES TRATADOS</strong><br />
        Los datos recogidos al registrarse o usar la app son:
        <ul>
          <li>Nombre</li>
          <li>Correo electrónico</li>
          <li>Sexo</li>
          <li>Gustos culinarios</li>
          <li>Información sobre interacciones dentro de la app</li>
        </ul>
        No se tratan datos especialmente sensibles (como salud, ideología, religión…).
      </li>
      <li>
        <strong>BASE LEGAL</strong><br />
        Las bases legales que legitiman el tratamiento son:
        <ul>
          <li>Consentimiento al aceptar los Términos y esta Política.</li>
          <li>Interés legítimo para fines analíticos y publicitarios no individualizados.</li>
        </ul>
      </li>
      <li>
        <strong>DESTINATARIOS</strong><br />
        Los datos se almacenan y procesan mediante servicios de terceros:
        <ul>
          <li>Firebase (Google LLC) — Backend, autenticación, base de datos.</li>
          <li>Algolia Inc. — Motor de búsqueda.</li>
          <li>OpenAI Inc. — Asistente conversacional.</li>
        </ul>
        Todos ellos cumplen el RGPD mediante Cláusulas Contractuales Tipo o escudos de privacidad equivalentes.<br />
        No se cederán los datos a terceros sin consentimiento, salvo obligación legal.
      </li>
      <li>
        <strong>CONSERVACIÓN DE LOS DATOS</strong><br />
        Los datos se conservarán:
        <ul>
          <li>Mientras dure la relación del usuario con la app.</li>
          <li>Hasta que se solicite su supresión.</li>
          <li>Durante los plazos exigidos por la ley una vez finalizada la relación.</li>
        </ul>
      </li>
      <li>
        <strong>DERECHOS DEL USUARIO</strong><br />
        Puedes ejercer los siguientes derechos:
        <ul>
          <li>Acceso a tus datos</li>
          <li>Rectificación de datos incorrectos</li>
          <li>Supresión (derecho al olvido)</li>
          <li>Limitación u oposición al tratamiento</li>
          <li>Portabilidad de tus datos</li>
        </ul>
        Para ejercerlos, escribe a cookychatapp@gmail.com adjuntando copia de tu DNI o documento identificativo.
      </li>
      <li>
        <strong>MENORES DE EDAD</strong><br />
        La app está dirigida exclusivamente a mayores de 18 años. No se permite el registro de menores.
      </li>
      <li>
        <strong>SEGURIDAD</strong><br />
        Se aplican medidas técnicas y organizativas para garantizar la confidencialidad, integridad y disponibilidad de tus datos personales.
      </li>
      <li>
        <strong>CAMBIOS EN LA POLÍTICA</strong><br />
        Podemos actualizar esta política en cualquier momento. Te lo notificaremos dentro de la app o mediante correo electrónico.
      </li>
    </ol>
  </div>
);

export default PrivacyPolicy;